<template>
  <div>
    <table class="linkanalytic-list__table">
      <thead class="linkanalytic-list__thead">
        <tr>
          <th class="linkanalytic-list__cell-name">名前</th>
          <th class="linkanalytic-list__cell-click">クリック数</th>
          <th class="linkanalytic-list__cell-percent">％</th>
        </tr>
      </thead>
      <tbody
        v-if="analyticData.length > 0"
        class="linkanalytic-list__tbody">
        <template v-for="item in analyticData">
          <template v-if="item.child_datas">
            <tr
              :key="item.id"
              class="linkanalytic-list__tr-parent"
              @click="toggleAccordion(item.name)">
              <td>{{ getName(item) }} <span :class="{open: isActive(item.name)}"></span></td>
              <td>{{ item.total_count }}</td>
              <td>{{ getRatios(item.total_count) }}</td>
            </tr>
            <transition
              :key="item.id"
              name="basic">
              <tr
                v-show="isActive(item.name)">
                <td
                  colspan="3"
                  class="linkanalytic-list-child__td">
                  <table class="linkanalytic-list-child__table">
                    <tbody>
                      <tr
                        v-for="child_item in item.child_datas"
                        :key="child_item.id">
                        <td class="linkanalytic-list__cell-name">{{ getName(child_item) }}</td>
                        <td class="linkanalytic-list__cell-click">{{ child_item.total_count }}</td>
                        <td class="linkanalytic-list__cell-percent">
                          {{ getRatios(child_item.total_count) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </transition>
          </template>
          <template v-else>
            <tr :key="item.id">
              <td>{{ getName(item) }}</td>
              <td>{{ item.total_count }}</td>
              <td>{{ getRatios(item.total_count) }}</td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'LinkAnalyticDetailTable',
  props: {
    analyticData: {
      type: Array,
      default: () => ([]),
      required: true,
    },
    displayName: {
      type: String,
      default: 'name',
    },
  },
  data() {
    return {
      ratios: {},
      showParentNames: [],
      sumCount: 0,
    }
  },
  watch: {
    analyticData() {
      this.setRations()
    },
  },
  methods: {
    getName(analyticData) {
      if (analyticData[this.displayName]) {
        return analyticData[this.displayName]
      }
      return 'なし'
    },
    getRatios(totalCount) {
      if (Object.keys(this.ratios).length === 0) {
        this.setRations()
      }
      let ration = this.ratios[totalCount]
      if (!ration) {
        const centesimal = 100 / this.sumCount
        ration = Math.round(centesimal * totalCount)
      }

      return ration
    },
    setRations() {
      if (!this.analyticData) {
        return
      }

      const totalCounts = this.analyticData.map((data) => {
        if (data.parent_name) {
          return undefined
        }

        return data.total_count
      }).filter(d => d)
      this.sumCount = totalCounts.reduce((sum, element) => Number(sum) + Number(element), 0)
      const totalCountsDuplicateDelete = Array.from(new Set(totalCounts))
      const centesimal = 100 / this.sumCount
      totalCountsDuplicateDelete.forEach(totalCount => {
        this.ratios[totalCount] = Math.round(totalCount * centesimal)
      })
    },
    toggleAccordion(parentName) {
      if (this.isActive(parentName)) {
        this.showParentNames = this.showParentNames.filter(n => n !== parentName)
      } else {
        this.showParentNames.push(parentName)
      }
    },
    isActive(parentName) {
      if (!parentName) {
        return true
      }
      return this.showParentNames.indexOf(parentName) >= 0
    },
  },
}
</script>

<style scoped>
.empty-cell {
  text-align: center;
  color: #505050;
  padding-top: 5vmin;
  padding-bottom: 5vmin;
}

@keyframes open {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
.basic-enter-active {
  animation: open .2s;
}
.basic-leave-active {
  animation: open .2s linear reverse;
}
</style>
